import React, { useEffect } from 'react';

import IMg1 from '../assets/img/aboutimg1.png';
import Img2 from '../assets/img/cancellation/cancel1.png';
import Line from '../assets/img/about/line.png';
import Img3 from '../assets/img/cancellation/cancel2.png';
import Img4 from '../assets/img/cancellation/cancel3.png';
import Img5 from '../assets/img/cancellation/cancel4.png';
import Img6 from '../assets/img/cancellation/cancel5.png';

import Img11 from '../assets/img/cancellation/cancel11.png';
import Img12 from '../assets/img/cancellation/cancel12.png';

import Icon1 from '../assets/img/about/icon1.png';
import Icon2 from '../assets/img/about/icon2.png';
import Icon3 from '../assets/img/about/icon3.png';
import Icon4 from '../assets/img/about/icon4.png';
import Icon11 from '../assets/img/about/icon11.png';
import Icon21 from '../assets/img/about/icon21.png';
import Icon31 from '../assets/img/about/icon31.png';
import Icon41 from '../assets/img/about/icon41.png';

import Start from '../assets/img/about/Star.png';


import SeoHelmet from "../components/SeoHelmet";

const CancellationPolicy = () => {

     useEffect(() => {
    document.body.classList.add('about-page');

    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <>
     <SeoHelmet />


        <section class="about cancellation">
            <div className='container'>
                <div className='mbrweb_row'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img2} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>Cancellation Policy</h2> 
                           <p>This Cancellation Policy explains what happens if you choose to cancel or reschedule.</p>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img3} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>1. Participant Cancellation (You cancel)</h2> 
                           <p>You may cancel your enrollment/slot by informing us in writing (email/WhatsApp as shared by our team).</p> 
                        <p><span>Cancellation does not qualify for a refund </span>(see Refund Policy).</p>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img4} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>2. Rescheduling / Batch Transfer (Credit Option)</h2> 
                           <p>We understand genuine scheduling issues can arise. If you inform us within the timelines below, we may offer a one-time transfer/credit option (at our discretion), subject to seat availability:</p> 
                            <div className='mbr_inner'>
                                <div className='mbr-col-sm-6'>
                                    <img src={Img11} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                    <h2>A) 1:1 Sessions / Personal Consultations</h2> 
                                    <p>Reschedule request must be made <span>at least 48 hours prior</span> to the scheduled session.</p> 
                                    <p>Requests under 48 hours or no-shows are considered consumed/forfeited.</p> 
                                </div>   
                            </div> 

                            <div className='mbr_inner'>
                                <div className='mbr-col-sm-6'>
                                    <img src={Img11} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                    <h2>B) Group Online Programs</h2> 
                                    <p>Transfer request must be made <span>at least 7 days before</span> the program start date.</p>
                                    <p>Under 7 days: transfer may not be possible due to batch planning and reserved capacity.</p> 
                                </div>   
                            </div> 

                            <div className='mbr_inner'>
                                <div className='mbr-col-sm-6'>
                                    <img src={Img11} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                    <h2>C) Offline Workshops / Offline Programs</h2> 
                                     <p>Transfer request must be made <span>at least 10 days before</span></p>
                                    <p>the start date (offline arrangements involve venue/vendor costs).</p> 
                                    <p>Under 10 days: transfer may not be possible.</p>  
                                </div>   
                            </div> 
                            <div className='warning'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img12} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                     <p><span className='important'>Important:</span>Transfers/credits (if granted) are typically valid for <span>90 days</span>   from the original program start date unless stated otherwise.</p>
                                  
                                </div>
                            </div>                      
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img5} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>3. Cancellation or Reschedule by Us</h2> 
                           <p>We may reschedule a session/program due to unforeseen circumstances (trainer availability, health, venue issues, force majeure, etc.). In such cases:</p> 
                        <p>we will provide an alternative date/session,</p>          
                        <p>if a full program is cancelled and no alternative is possible, the Refund Policy "Program Cancelled by Us" clause applies.</p>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img6} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>4. Force Majeure</h2> 
                           <p>We are not liable for delays/cancellations due to events beyond reasonable control (natural events, government restrictions, strikes, internet outages, platform failures, etc.). We will attempt to provide a reasonable alternative.</p>                          
                        </div>
                    </div>
                </div>

                <div className='mbr_bottom'>
                    <p>
                        For questions about this policy, please contact our support team.
                    </p>
                </div>
            </div>
        </section>
        {/* <section class="clients">
            <div class="container">
                <div className='numbox'>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon1} /><img className='about_icon1' src={Icon11} />
                        <div>
                            <p>1000+</p>
                            <span>Lives Transformed</span>
                        </div>
                    </div>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon2} /><img className='about_icon1' src={Icon21} />
                         <div>
                            <p>10+</p>
                            <span>Years of Experience</span>
                        </div>
                    </div>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon3} /><img className='about_icon1' src={Icon31} />
                         <div>
                            <p>5+</p>
                            <span>Pageants  Judged</span>
                        </div>
                    </div>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon4} /><img className='about_icon1' src={Icon41} />
                         <div>
                            <p>1</p>
                            <span>Brand Built</span>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
        {/* <section class="bio">
            <div className='container'>
                <p>“I envision a world where you conquer your fears, shatter limitations, and live a life of unparalleled success. You command respect, radiate confidence, and inspire others to reach for their own greatness. Always remember, you are a force to be reckoned with!”</p>
            </div>
      
            <div class="breaking-news">
                <div class="breaking-news__marquee">
                    <div class="breaking-news__inner">
                        <span><a href="/personality-development-courses"><img src={Start}></img><p>Join Transform with Bhavana Singh | 2 Weeks Intensive Program 6oct-12th oct</p></a></span>
                        <span><a href="/personality-development-courses"><img src={Start}></img><p>Join Transform with Bhavana Singh | 2 Weeks Intensive Program 6oct-12th oct</p></a></span>
                    </div>
                </div>
            </div>
        </section> */}
    </>
  );
}; 

export default CancellationPolicy;
